<template>
  <v-card class="back" style="height: 800px">
    <v-layout fill-height>
      <v-flex >
        <v-layout column fill-height>
          <scroll-area>
            <template slot="header">
              <v-toolbar dark color="secondary" dense flat>
                <v-toolbar-title>
                  <span class="body-2 text-uppercase">VLAN {{ getData.vlanName }}</span>
                </v-toolbar-title>
                <v-layout  justify-end>
                <v-tooltip dark color="secondary" bottom>
                  <v-btn :data-testid="$options.name + 'v-btn' + 'emit-close'" icon flat slot="activator" @click="()=>{$emit('close')}">
                    <svg-icon
                      :color="'white'"
                      :name="'close'"
                      width="20"
                    />
                  </v-btn>
                  <span>{{ $t('close') }}</span>
                </v-tooltip>
              </v-layout>
              </v-toolbar>             
            </template>

            <template slot="body">
              <v-layout column v-show="!groupUse" fill-height justify-start class="pa-2">
                <v-layout shrink v-for="(field, index) in Object.keys(getFields) " :key="index" >
                  <v-flex xs4 shrink px-0 pb-2>
                    <v-text-field
                      :value="$t(field)"
                      light
                      outline
                      flat
                      readonly
                      disabled
                      class="backgrey"
                      persistent-hint
                      hide-details
                      :rows="1"
                      color="white"
                    >
                    </v-text-field>
                  </v-flex>
                  
                  <v-flex xs8 shrink px-0 pb-2>
                    <v-tooltip v-if="getDescriptions[field]" dark color="secondary" bottom>
                      <v-text-field
                        v-if="field.type == 'integer'"
                        v-model.number="model.obj[field]"
                        slot="activator"
                        :type="'number'"
                        light
                        auto-grow
                        outline
                        class="white"
                        persistent-hint
                        hide-details
                        :rows="1"
                        color="accent"
                      >
                      </v-text-field>
                      <v-text-field :data-testid="$options.name + 'v-text-field' + field"
                        v-else
                        v-model="model.obj[field]"
                        slot="activator"
                        light
                        auto-grow
                        outline
                        class="white"
                        persistent-hint
                        hide-details
                        :rows="1"
                        color="accent"
                      >
                      </v-text-field>
                      <span >{{ $t(getDescriptions[field]) }}</span>
                    </v-tooltip>

                    <v-text-field
                      v-if="!getDescriptions[field] && !getItems[field]"
                      v-model.number="model.obj[field]"
                      light
                      auto-grow
                      outline
                      class="white"
                      persistent-hint
                      hide-details
                      :rows="1"
                      color="accent"
                    >
                    </v-text-field>

                    <v-select
                      v-if="!getDescriptions[field] && getItems[field]"
                      :data-testid="$options.name + '__select__' + field"
                      v-model="model.obj[field]"
                      light
                      :items="getItems[field]"
                      outline
                      hide-details
                      class="white"
                      background-color="backgrey"
                      clearable
                    >
                    </v-select>


                  </v-flex>
                </v-layout>
              </v-layout>
            </template>

            <template slot="footer">
              <v-layout fill-height>
                <v-layout fill-height justify-start>
                  <v-btn :data-testid="$options.name + 'v-btn' + 'createData'" v-if="addMode" dark small @click="()=>createData()" color="success">{{$t('save')}}</v-btn>
                  <v-btn :data-testid="$options.name + 'v-btn' + 'saveData'" v-if="!addMode && !groupUse" dark small @click="()=>saveData()" color="success">{{$t('upload to device')}}</v-btn>
                  <v-btn :data-testid="$options.name + 'v-btn' + 'upload-to-devices'" v-if="!addMode && groupUse" dark small @click="" color="success">{{$t('upload to devices')}}</v-btn>
                  <v-btn :data-testid="$options.name + 'v-btn' + 'removeItem'" v-if="!addMode && !groupUse" small @click="()=>removeItem()" color="grey">{{$t('remove')}}</v-btn>
                </v-layout>
                <v-layout fill-height justify-end>
                  <v-btn :data-testid="$options.name + 'v-btn' + 'groupUse--true'" v-if="!groupUse" dark small @click="()=>{groupUse = true}" color="success">{{$t('group use')}}</v-btn>
                  <v-btn :data-testid="$options.name + 'v-btn' + 'emit-close'" v-if="!groupUse" small @click="()=>{$emit('close')}" color="grey">{{$t('close')}}</v-btn>                 
                </v-layout>
              </v-layout>
            </template>

          </scroll-area>
        </v-layout>
      </v-flex>
      <v-flex v-show="groupUse" xs12 >
        <scroll-area>
          <template slot="header">
            <v-toolbar dark color="secondary" dense flat>
              <v-toolbar-title>
                <span class="body-2 text-uppercase">Tree</span>
              </v-toolbar-title>
            </v-toolbar>             
          </template>

          <template slot="body">
            <scroll-table
              :subscribed="false"
              :data="getTable"
              :options="getOptions"
            />
          </template>

          <template slot="footer">
            <v-layout fill-height>
              <v-layout fill-height justify-start>
                <v-btn :data-testid="$options.name + 'v-btn' + 'createData'" v-if="addMode" dark small @click="()=>createData()" color="success">{{$t('save')}}</v-btn>
                <v-btn :data-testid="$options.name + 'v-btn' + 'saveData'" v-if="!addMode && !groupUse" dark small @click="()=>saveData()" color="success">{{$t('upload to device')}}</v-btn>
                <v-btn :data-testid="$options.name + 'v-btn' + 'upload-to-devices'" v-if="!addMode && groupUse" dark small @click="()=>saveData()" color="success">{{$t('upload to devices')}}</v-btn>
                <v-btn :data-testid="$options.name + 'v-btn' + 'groupUse_removeItem'" v-if="!addMode && groupUse" small @click="()=>removeItem()" color="grey">{{$t('remove')}}</v-btn>
              </v-layout>
              <v-layout fill-height justify-end>             
                <v-btn :data-testid="$options.name + 'v-btn' + 'groupUse--false'" v-if="groupUse" small @click="()=>{groupUse = false}" color="grey">{{$t('cancel')}}</v-btn>                 
              </v-layout>
            </v-layout>
          </template>
        </scroll-area>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import { CCMDBObject } from '@entcor/ebridge'

// Типы
interface DeviceLink {
  $id?: string
  name?: string
  path?: string
  selected?: boolean
  [key: string]: any
}

interface ModelData {
  devices: any[]
  fields: Record<string, any>
  obj: Record<string, any>
  items: Record<string, any>
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface TableData {
  columns: TableColumn[]
  rows: DeviceLink[]
}

interface TableColumn {
  title: string
  value: string
  type: string
  width: string
}

interface RestCardData {
  [key: string]: any
}

interface ParentData {
  template?: string
  [key: string]: any
}

interface DescriptionsData {
  [key: string]: any
}

interface DescriptorsMap {
  [key: string]: Descriptor
}

interface Descriptor {
  name: string
  type?: string
  method: {
    get?: DescriptorMethod
    update?: DescriptorMethod
    add?: DescriptorMethod
    remove?: DescriptorMethod
  }
  dataModel?: {
    data?: any[]
  }
  [key: string]: any
}

interface DescriptorMethod {
  name: string
  rest?: string
  parameters?: Record<string, any>
  accepts?: Record<string, any>
}

interface CmdbQueryResult {
  links?: DeviceLink[]
  [key: string]: any
}

export default Vue.extend({
  name: 'REST_CARD',

  components: {
    scrollTable,
    scrollArea,
    svgIcon,
  },

  props: {
    data: {
      type: Object as () => RestCardData,
      default: () => ({})
    },
    parentData: {
      type: Object as () => ParentData,
      default: () => ({})
    },
    addMode: {
      type: Boolean,
      default: () => false
    },
    descriptions: {
      type: Object as () => DescriptionsData,
      default: () => ({})
    },
    descriptors: {
      type: Object as () => DescriptorsMap,
      default: () => ({})
    },
  },

  data(): {
    model: ModelData
    groupUse: boolean
    options: OptionsData
    search: string
    table: TableData
  } {
    return {
      model: {
        devices: [],
        fields: {},
        obj: {},
        items: {}
      },
      groupUse: false,
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          check: { width: '20%' },
          check_dependence: { width: '5%' },
        },
      },
      search: '',
      table: {
        columns: [
          {
            title: 'select',
            value: 'selected',
            type: 'check_box',
            width: '5%'
          },
          {
            title: 'name',
            value: 'name',
            type: 'text',
            width: '30%',
          },
          {
            title: 'disposition',
            value: 'path',
            type: 'text',
            width: '65%',
          },
        ],
        rows: []
      },
    }
  },

  computed: {
    getData(): RestCardData {
      return this.data
    },
    getFields(): Record<string, any> {
      return this.model.fields
    },
    getItems(): Record<string, any> {
      return this.model.items
    },
    getDescriptions(): DescriptionsData {
      return this.descriptions
    },
    getDescriptors(): DescriptorsMap {
      return this.descriptors
    },
    getTable(): TableData {
      return this.$merge({}, this.table) as TableData
    },
    getOptions(): OptionsData {
      return this.options
    },
  },

  created(): void {
    this.prepareData()
    this.loadGroup()
  },

  methods: {
    prepareData(): void {
      this.$set(this.model, 'fields', {})
      this.$set(this.model, 'obj', {})
      
      Object.keys(this.getData).forEach(key => {
        this.$set(this.model.fields, key, this.getData[key])
        this.$set(this.model.obj, key, this.getData[key])
      })

      if(Object.keys(this.getDescriptors).length) {
        let name = Object.keys(this.getDescriptors)[0]
        let enums = this.getDescriptors[name]?.enums ? this.getDescriptors[name].enums : null
        if(enums) {
          this.$set(this.model, 'items', enums)
        }
      }
      // console.log(this.$options.name, 'prepareData', 'this.getData', this.getData)
      // console.log(this.$options.name, 'prepareData', 'model.fields', this.model.fields)
      // console.log(this.$options.name, 'prepareData', 'model.obj', this.model.obj)
      // console.log(this.$options.name, 'prepareData', 'getDescriptions', this.getDescriptions)
      console.log(this.$options.name, 'prepareData', 'getDescriptors', this.getDescriptors)
    },

    async loadGroup(): Promise<void> {
      console.log(this.$options.name, 'loadGroup', 'start', this.parentData)
      try {
        const query = {
          id: ['/physical'],
          cls: 'device',
          notNull: true,
          data: {
            namePath: true,
            links: {
              flatten: true,
              filter: { template: this.parentData.template },
              namePath: true,
            }
          }
        }
        const t = await this.$bridge.cmdbQuery(query) as CmdbQueryResult[]
        console.log(this.$options.name, 'loadGroup', 't', t)
        
        if (t?.length && t[0].links?.length) {
          this.prepareTable(t[0].links)
        }
      } catch (error) {
        console.error(this.$options.name, 'loadGroup smth wrong', error)
      }
    },

    async prepareTable(payload: DeviceLink[]): Promise<void> {
      if (!payload) return
      console.log(this.$options.name, 'prepareTable', 'payload', payload)
      
      try {
        this.table.rows = []
        payload.forEach(device => {
          const obj: DeviceLink = {
            $id: device.$id,
            name: device.name,
            path: device.path,
            selected: false
          }
          this.table.rows.push(obj)
        })
        console.log(this.$options.name, 'prepareTable', 'this.table.rows', this.table.rows)
      } catch (error) {
        console.error(this.$options.name, 'loadGroup smth wrong', error)
      }
    },

    removeItem(): void {
      this.$dialog.confirm({
        text: 'Удалить ...?',
        title: 'Удаление',
        actions: {
          false: 'Отмена',
          true: {
            color: 'red',
            text: 'Удалить',
            handle: () => {
              if (!this.groupUse) {
                  const payload = this.model.obj
                  this.$emit('remove', payload)
                } else {
                  console.log(this.$options.name, 'removeItem', 'this.table.rows', this.table.rows)
                  const arr: string[] = []
                  this.getTable.rows.forEach(row => {
                    if (row.selected) {
                      arr.push(row.$id as string)
                    }
                  })
                  const payload = { obj: this.model.obj, group: arr }
                  this.$emit('remove', payload)
                }
                this.$emit('close')
            }
          }
        }
      })
    },

    async saveData(): Promise<void> {
      try {
        this.$dialog.confirm({
          text: 'Сохранить изменения?',
          title: 'Сохранение',
          actions: {
            false: 'Отмена',
            true: {
              color: 'green',
              text: 'Сохранить',
              handle: () => {
                if (!this.groupUse) {
                  const payload = this.model.obj
                  console.log(this.$options.name, 'saveData', 'payload', payload)
                  this.$emit('update', payload)
                } else {
                  console.log(this.$options.name, 'saveData', 'this.table.rows', this.table.rows)
                  const arr: string[] = []
                  this.getTable.rows.forEach(row => {
                    if (row.selected) {
                      arr.push(row.$id as string)
                    }
                  })
                  const payload = { obj: this.model.obj, group: arr }
                  this.$emit('update', payload)
                }
                this.$emit('close')
              }
            }
          }
        })
      } catch (err) {
        this.$errorHandler(err)
      }
    },

    async createData(): Promise<void> {
      try {
        // console.log(this.$options.name, 'createData', 'start', this.getTable)
        this.$dialog.confirm({
          text: 'Создать новое ...?',
          title: 'Создать новое ...',
          actions: {
            false: 'Отмена',
            true: {
              color: 'green',
              text: 'Создать',
              handle: () => {
                if (!this.groupUse) {
                  const payload = this.model.obj
                  this.$emit('add', payload)
                } else {
                  // console.log(this.$options.name, 'createData', 'this.getTable', this.getTable)
                  const arr: string[] = []
                  this.getTable.rows.forEach(row => {
                    if (row.selected) {
                      arr.push(row.$id as string)
                    }
                  })
                  const payload = { obj: this.model.obj, group: arr }
                  this.$emit('add', payload)
                }
                this.$emit('close')
              }
            }
          }
        })
      } catch (err) {
        this.$errorHandler(err)
      }
    },
  },
})
</script>

<style lang="stylus" scoped>
.rule
  border 1px solid #c1c163
  margin-bottom: 5px;
  padding: 5px;
.rule-item
  //border 1px solid red
  display flex
  justify-content stretch
  align-items baseline
  .field
    margin 0 3px
    outline: darkgray solid 1px;
    height: 30px;
    padding-left: 5px;
    line-height: 30px;
    background-color: white;
.v-btn.supersmall
  padding-top: 4px
  height: 24px
  width: 24px
  right: 5px
</style>
